import humps from 'humps'
import {isEmpty} from 'lodash'

import api from '@/lib/api'

export default {
  namespaced: true,

  state: {
    token: null,
    show: false,
  },
  getters: {},
  mutations: {
    token: (s, p) => {
      s.token = isEmpty(p) ? null : p
    },
    show: (s, b) => {
      s.show = b
    },
  },
  actions: {
    async generateToken({commit}, p) {
      try {
        const resp = await api.event.token.generate(p.eventId, p.tacId, p.expDate)
        commit('token', humps.camelizeKeys(resp.data))
      } catch (e) {
        commit('token', null)
      }
    },
  },
}
